import { LISTING_TYPES } from "repoV2/features/Listing/Listing.constants";

export const getSessionDetailsHeader = ({
    listingType,
    classesCount,
}: {
    listingType: number;
    classesCount: number;
}) => {
    const sessionDetailsHeader = {
        [LISTING_TYPES.WEBINAR]: "Session Details",
        [LISTING_TYPES.WORKSHOPS]: "Schedule",
        [LISTING_TYPES.APPOINTMENTS]: "Select Slots",
        [LISTING_TYPES.GROUP_CLASSES]:
            classesCount === 1 ? "Batch Details" : "Select a batch",
        [LISTING_TYPES.ROLLING_CLASSES]:
            classesCount === 1 ? "Batch Details" : "Select a batch",
        [LISTING_TYPES.ONE_ON_ONE_CLASSES]:
            classesCount === 1 ? "Batch Details" : "Select a batch",
    };

    return sessionDetailsHeader[listingType];
};

export const selected_session_details_form_key = "selected_session_details";
